<template>
    <ErrorLayout
        supertitle="errors.timeout"
        title="errors.somethingWentWrong"
        subtitle="errors.pleaseTryAgainOrContactSupport" />
</template>
